import { useCssVars as _useCssVars } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-989f588e"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "home"
};
var _hoisted_2 = {
  class: "pc"
};
var _hoisted_3 = {
  class: "side-nav"
};
var _hoisted_4 = {
  class: "h-page"
};
var _hoisted_5 = {
  class: "header"
};
var _hoisted_6 = {
  class: "header-inner"
};
var _hoisted_7 = {
  class: "h-main"
};
import Menu from './Menu';
import Headers from './headers';
import { computed } from 'vue';
import { useStore } from 'vuex';
import variables from '@/styles/variables.scss';
export default {
  setup: function setup(__props) {
    _useCssVars(function (_ctx) {
      return {
        "715a38a0": _unref(asideWidth)
      };
    });

    var store = useStore();
    var asideWidth = computed(function () {
      return store.getters.siderType ? variables.sideBarWidth : variables.hideSideBarWidth;
    });
    return function (_ctx, _cache) {
      var _component_router_view = _resolveComponent("router-view");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_unref(Menu))]), _createElementVNode("div", {
        class: _normalizeClass(["right", {
          hidderSideBar: !_ctx.$store.getters.siderType
        }])
      }, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createVNode(_unref(Headers))])]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_router_view)])])], 2)])]);
    };
  }
};